
import { FC, RefObject, useCallback, useEffect } from "react";
import * as styles from "./FadeScroll.module.scss";

type fadeScrollProps = {
  refChild: RefObject<HTMLElement>;
  refScrollContainer: RefObject<HTMLElement>;
};

const FadeScroll: FC<fadeScrollProps> = ({ refChild, refScrollContainer }) => {
  const resizeFadeTrigger = useCallback(() => {

      if (refChild.current && refScrollContainer.current) {
        const { clientHeight } = refScrollContainer.current;
        refScrollContainer.current.classList.toggle(
          styles.activeBot,
          refChild.current.clientHeight > clientHeight
        );
      }

    
  }, []);

  const onScrollShowFade = useCallback(() => {
    if (refChild.current && refScrollContainer.current) {
      const {
        scrollTop: parentScrollTop,
        scrollHeight: parentScrollHeight,
        clientHeight: parentClientHeight,
      } = refScrollContainer.current;

      const isNearBottom =
        parentScrollTop + parentClientHeight >= parentScrollHeight;
      refScrollContainer.current.classList.toggle(
        styles.active,
        parentScrollTop > 0
      );
      isNearBottom &&
        refScrollContainer.current.classList.remove(styles.activeBot);
      !isNearBottom &&
        refScrollContainer.current.classList.add(styles.activeBot);
    }
  }, []);

  useEffect(() => {
    const parentContainer = refScrollContainer.current;
    if (parentContainer && refChild.current) {
      const resizeObserver = new ResizeObserver(() => {
        resizeFadeTrigger();
      });

      resizeObserver.observe(refChild.current);
      parentContainer.addEventListener("scroll", onScrollShowFade);

      return () => {
        resizeObserver.disconnect();
        parentContainer.removeEventListener("scroll", onScrollShowFade);
      };
    }
  }, [refChild, refScrollContainer]);

  return <></>;
};

export default FadeScroll;
